import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { TypeEvaluationDetailPage } from "..";
import { TypeEvaluationApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface ITypeEvaluationItemPageProps {}

export const TypeEvaluationItemPage: React.FunctionComponent<ITypeEvaluationItemPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();

  const typeEvaluationApi = useApiService(TypeEvaluationApi);
  const [displayName] = useApiEffect(() => typeEvaluationApi.typeEvaluationGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.TypesEvaluation), route: ERoutes.typeEvaluation },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabDetail"
        onChange={newTabId => history.push(`${ERoutes.typeEvaluation}/${id}/${newTabId}`)}
        renderActiveTabPanelOnly
        selectedTabId={tab}
      >
        <BackButton backRoute={ERoutes.typeEvaluation}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<TypeEvaluationDetailPage idTypeEvaluation={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
